import { LeftOutlined, RightOutlined, StarFilled, StarTwoTone } from '@ant-design/icons';
import { Button, Input, message, Modal, Select, Tooltip } from 'antd';
import { delay } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';

import { trackButtonClick } from '../../analytics/mixpanel';
import CompareErr from '../../assets/CompareErr';
import FilterIcon from '../../assets/FilterIcon';
import ViewerFormat from '../../assets/ViewerFormat';
import ZeroResultIcon from '../../assets/ZeroResultIcon';
import CompareFilters from '../../CommonComponents/CompareFilters/CompareFilters';
import ComparisonCard from '../../CommonComponents/ComparisonCard/ComparisonCard';
import Loader from '../../CommonComponents/Loader';
import Navbar from '../../CommonComponents/Navbar/Navbar';
import SavedComparisonsSidebar from '../../CommonComponents/SavedComparisonsSidebar/SavedComparisonsSidebar';
import ShareFileComparison from '../../CommonComponents/shareFileComparison';
import ViewerDiv from '../../CommonComponents/ViewerDiv/ViewerDiv';
import { extractUrlParams, shortenStringWithEllipsis } from '../../CommonFuctions/Utils';
import { sharableUrl } from '../../config';
import {
  DOC_COMPARE,
  firstChange,
  lastChange,
  LOADING,
  modifiedDocument,
  nextChange,
  originalDocument,
  prevChange,
  RE_ANALYSIS,
  SAVED,
  SHARED,
  singleDocument,
  SUCCESS,
} from '../../Constants/commonConstants';
import {
  addRemoveBookmark,
  documentCompare,
  getSavedComparisons,
  getSharedComparisonData,
  renameTitle,
} from '../../Redux/FileCompare/fileCompareActions';
import { setDocCompareSidebar, sidebarStateSelector } from '../../Redux/sidebar/sidebarReducer';
import { useBackToID } from '../../utils/hooks/useBackToID';
import ViewerFooter from './ViewerFooter';

// Function to debounce a value
const useDebounce = (value, delayTime) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delayTime);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delayTime]);

  return debouncedValue;
};

Element.prototype.scrollIntoViewPromise = function (options, time = 300) {
  this.scrollIntoView(options);
  setTimeout(() => {
    this.scrollIntoView({ behavior: 'auto' });
  }, time);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 400);
  });
};

const regexForNumber = /^[0-9]+$/;

let canLoadCards = true;
let canLoadPage = [true, true, true];
let isScrolling = false;
const cardsTimerId = null;
let timerId = null;
let lastIndex = 50;
const fistCardTimer = {
  leftId: null,
  rightId: null,
  cardId: null,
};
const scrollFunctionTimer = {
  docId: null,
  cardId: null,
};
let previousElement = null;

function Viewer() {
  const dispatch = useDispatch();
  const compareData = useSelector((state) => state.compareData);

  // Activate useBackToID hook for doccompare product
  useBackToID(DOC_COMPARE);

  const { getSavedCompareStatus, reAnalysisStatus, savedComparisons } = compareData;
  const navigate = useNavigate();
  const [page, setPage] = useState({
    ORIGINAL_DOCUMENT: {
      number: 1,
      currentMax: 10,
    },
    MODIFIED_DOCUMENT: {
      number: 1,
      currentMax: 10,
    },
    SINGLE_DOCUMENT: {
      number: 1,
      currentMax: 10,
    },
  });
  const [card, setCard] = useState({
    id: 0,
    index: 0,
    kind: '',
    page_index: 0,
  });
  const [visibleIndex, setVisibleIndex] = useState(null);
  const [zoomLevel, setZoomLevel] = useState({
    ORIGINAL_DOCUMENT: 0.9,
    MODIFIED_DOCUMENT: 0.9,
    SINGLE_DOCUMENT: 0.9,
  });
  const [documentDetails, setDocumentDetails] = useState({});
  const [cardData, setCardData] = useState([]);
  const [annotationOutlineData] = useState([]);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [isLoaderOpen, setIsLoaderOpen] = useState(true);
  // TODO: make allCardData as local variable
  const [allCardData, setAllCardData] = useState([]);
  const [comparisonCards, setComparisonCards] = useState([]);
  const [contradictionCards, setContradictionCards] = useState([]);
  const [editTitle, setEditTitle] = useState({
    isVisible: false,
    tempTitle: '',
    duplicateFound: false,
    editLoader: false,
  });
  const [totalRegionPages, setTotalRegionPages] = useState({
    leftRegion: 10,
    rightRegion: 10,
    singleRegion: 10,
  });
  const [isHeadingFilterOn] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const scrollTimeoutRef = useRef(null);
  // TODO: what is the use of this ref
  const filterRef = useRef(null);
  const [searchResultData, setSearchResultData] = useState([]);
  const [searchingText] = useState('');
  const [headingData, setHeadingData] = useState(compareData.headingsData);
  const [showOnlySearchResults] = useState(false);
  // TODO: use local variable
  const [checkBoxDetails, setCheckBoxDetails] = useState({
    originalTotalPage: 0,
    modifiedTotalPage: 0,
    singleViewTotalPage: 0,
  });

  const debouncedSearchText = useDebounce(searchingText, 1000);

  const [clickTimeout, setClickTimeout] = useState(null);
  const [filter, setFilter] = useState({
    showComparison: ['ALL_DOCUMENTS'],
    showContradiction: [],
    showBookmark: false,
    isActive: false,
  });
  const [filteredCards, setFilteredCards] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  const [currentDocument, setCurrentDocument] = useState({
    left: 0,
    right: 1,
  });
  const [tabView, setTabView] = useState(true);
  const [showError, setShowError] = useState({
    flag: false,
    isComparisonErr: false,
    isContradictionErr: false,
  });
  const tabsScrollRef = useRef(null);
  const { docCompareSidebarVisible } = useSelector(sidebarStateSelector);

  const removeUnmatchedHeadings = (arr) => {
    return arr.filter(
      (item) =>
        item.heading.toLowerCase().includes(searchingText.toLowerCase()) ||
        searchNestedArray(item.sub_headings || [], searchingText.toLowerCase())
    );
  };

  // useEffect Start---->
  useEffect(() => {
    if (Object.keys(savedComparisons)?.length === 0) {
      dispatch(getSavedComparisons());
    }
  }, []);

  useEffect(() => {
    if (Object.values(contradictionCards).includes(null)) {
      setShowError((prev) => ({
        ...prev,
        flag: true,
        isContradictionErr: true,
      }));
    }
    if (!comparisonCards) {
      setShowError((prev) => ({
        ...prev,
        flag: true,
        isComparisonErr: true,
      }));
    }
    const filteredContradictionCards = Object.entries(contradictionCards)
      .filter(([fileName]) => filter.showContradiction.includes(fileName) && !filter?.showBookmark)
      .flatMap(([fileName, contradictions]) =>
        (contradictions || [])?.map((cardItem, index) => ({
          ...cardItem,
          type: 'contradiction',
          sourceDoc: fileName,
          id: `${fileName}-${index}`,
        }))
      );

    const filteredComparisonCards =
      filter?.showComparison?.length || filter?.showBookmark
        ? (comparisonCards || []).reduce((acc, cardItem, index) => {
            const matchesComparison =
              filter?.showComparison?.includes('ALL_DOCUMENTS') ||
              cardItem?.Types?.some((type) => filter.showComparison.includes(type));

            const matchesBookmark = !filter?.showBookmark || cardItem?.shortlist;

            if (matchesComparison && matchesBookmark) {
              acc.push({ ...cardItem, type: 'comparison', id: `comparison-${index}` });
            }

            return acc;
          }, [])
        : [];

    setFilteredCards([...filteredComparisonCards, ...filteredContradictionCards]);
  }, [filter, comparisonCards, contradictionCards]);

  useEffect(() => {
    if (searchResultData.length === 0) return;
    const id = `exact-match-${searchResultData[0]}`;
    setTimeout(() => {
      underlineElement(id);
      const element = document?.getElementById(id);
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 500);
  }, [searchResultData]);

  useEffect(() => {
    if (showOnlySearchResults) {
      const newArray = removeUnmatchedHeadings(compareData.headingsData);
      setSearchResultData([]);

      if (newArray.length > 0) {
        printRecursion(newArray, [], []);
      } else {
        setHeadingData([]);
      }
    } else {
      printRecursion(compareData?.headingsData, [], []);
    }
  }, [debouncedSearchText, showOnlySearchResults, compareData.headingsData, searchingText]);

  useEffect(() => {
    dataSourceHandler(compareData);
  }, []);
  useEffect(() => {
    setHeadingData(compareData.headingsData);
  }, [compareData.headingsData]);
  useEffect(() => {
    printRecursion(headingData, [], []);
  }, [isHeadingFilterOn]);

  useEffect(() => {
    setDocumentDetails(compareData);
  }, [
    compareData.finalComparison,
    reAnalysisStatus,
    compareData.comparisonResults,
    compareData.contradictionResults,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !document.querySelectorAll('.filter-btn')[0]?.contains(event.target)
      ) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [setIsFilterOpen]);

  useEffect(() => {
    // TODO:
    if (allCardData?.length === 0) {
      setCardData([]);
      setVisibleIndex(null);
      setCard({
        id: 0,
        index: 0,
        kind: '',
        page_index: 0,
      });
    } else {
      setCardData(allCardData.slice(0, 50));
      setVisibleIndex(allCardData[0]?.id);
      setCard({
        id: allCardData[0]?.id,
        index: 0,
        page_index: allCardData[0].page_index,
        kind: allCardData[0].kind,
      });

      const leftId = `${allCardData[0]?.id}-` + 'leftRegion';
      const rightId = `${allCardData[0]?.id}-` + 'rightRegion';
      lastIndex = 50;
      canLoadCards = true;

      setTimeout(() => {
        scrollFunction(
          leftId,
          rightId,
          allCardData[0]?.id,
          allCardData[0]?.page_index,
          allCardData[0]?.kind
        );
      }, 500);
    }
  }, [allCardData, compareData]);

  useEffect(() => {
    if (documentDetails?.comparisonResults || documentDetails?.contradictionResults) {
      // const filteredDataForAnnotation = documentDetails?.annotationData;
      // setAnnotationOutlineData(filteredDataForAnnotation);
      // setVisibleIndex(documentDetails?.finalComparison[0]?.id);
      // setAllCardData(documentDetails?.finalComparison);
      setComparisonCards(documentDetails?.comparisonResults);
      setContradictionCards(documentDetails?.contradictionResults);
      if (!filter?.showBookmark && !filter?.isActive) {
        setFilter((prev) => ({
          ...prev,
          showContradiction:
            documentDetails?.contradictionResults &&
            Object.keys(documentDetails?.contradictionResults),
        }));
      }
    }
  }, [
    documentDetails.comparisonResults,
    documentDetails.contradictionResults,
    documentDetails.modifiedDocumentURL,
    documentDetails.originalDocumentURL,
    documentDetails.finalComparison,
  ]);

  useEffect(() => {
    canLoadCards = true;
    isScrolling = false;
    lastIndex = 50;
    setCheckBoxDetails({
      originalTotalPage: documentDetails?.documentsMetaData?.[currentDocument?.left]?.total_page,
      modifiedTotalPage: documentDetails?.documentsMetaData?.[currentDocument?.right]?.total_page,
      singleViewTotalPage: documentDetails?.documentsMetaData?.[currentTab]?.total_page,
    });
    setTotalRegionPages({
      leftRegion: 10,
      rightRegion: 10,
      singleRegion: 10,
    });
    canLoadPage = [true, true, true];
  }, [
    // documentDetails.originalDocumentURL,
    // documentDetails.modifiedDocumentURL,
    // reAnalysisStatus,
    currentTab,
    currentDocument,
    tabView,
  ]);

  // documentsMetaData can finish loading (or be refreshed by an unrelated
  // action, e.g. bookmarking a card) without currentTab/currentDocument/tabView
  // changing. Recompute checkBoxDetails so total_page is never read from a
  // stale/not-yet-loaded documentsMetaData. Deliberately excludes the
  // pagination reset above (totalRegionPages/canLoadPage), which must only
  // reset on an actual tab/document/view switch.
  useEffect(() => {
    setCheckBoxDetails({
      originalTotalPage: documentDetails?.documentsMetaData?.[currentDocument?.left]?.total_page,
      modifiedTotalPage: documentDetails?.documentsMetaData?.[currentDocument?.right]?.total_page,
      singleViewTotalPage: documentDetails?.documentsMetaData?.[currentTab]?.total_page,
    });
  }, [
    documentDetails?.documentsMetaData,
    currentDocument?.left,
    currentDocument?.right,
    currentTab,
  ]);

  useEffect(() => {
    timerId = setTimeout(() => {
      if (extractUrlParams('type') === SHARED || extractUrlParams('type') === SAVED) {
        if (compareData.compareStatus === SUCCESS) {
          setIsLoaderOpen(false);
        }
      } else if (compareData.compareStatus === LOADING || getSavedCompareStatus === LOADING) {
        if (!editTitle) {
          setIsLoaderOpen(true);
        }
      } else {
        setIsLoaderOpen(false);
      }
    }, 1600);

    return () => {
      clearTimeout(timerId);
      clearTimeout(cardsTimerId);
      setCardData([]);
      canLoadPage[0] = true;
      canLoadPage[1] = true;
      canLoadPage[2] = true;
      fistCardTimer.leftId = null;
      fistCardTimer.rightId = null;
      fistCardTimer.cardId = null;
      scrollFunctionTimer.docId = null;
      scrollFunctionTimer.cardId = null;
    };
  }, [compareData.compareStatus, getSavedCompareStatus, reAnalysisStatus]);

  // useEffect(() => {
  //   if (
  //     extractUrlParams('type') !== SHARED &&
  //     localStorage.getItem('isCompareTourCompleted') !== 'false'
  //   ) {
  //     // props?.getSubscription();
  //   }
  //   const isCompareTourCompleted =
  //     localStorage.getItem('isCompareTourCompleted') === 'true';

  //   if (!isMounted.current) {
  //     isMounted.current = true;
  //     return;
  //   }
  //   setViewTour(!isCompareTourCompleted && !isLoaderOpen);
  //   if (!isCompareTourCompleted && !isLoaderOpen) {
  //     setIsFilterOpen(true);
  //   }
  //   if (viewTour) {
  //     handleClickOutside.current = null;
  //     setTimeout(() => {
  //       applyStyleToClass('ant-modal-mask', 'background-color');
  //     }, 10);
  //   } else {
  //     setIsFilterOpen(false);
  //   }
  // }, [viewTour, props?.take_tour_doc_compare, isLoaderOpen]);

  // useEffect End---->

  // Datasource handler for shared and saved comaprison start---
  const dataSourceHandler = (compareDataObj) => {
    const id = extractUrlParams('uuid');
    if (id && extractUrlParams('type') === SAVED) {
      if (compareDataObj?.modifiedDocumentURL === '' || extractUrlParams('type') === SAVED) {
        dispatch(documentCompare({ id, navigate }));
      }
    } else if (id && extractUrlParams('type') === SHARED) {
      dispatch(getSharedComparisonData({ id, navigate }));
    } else if (compareDataObj.modifiedDocumentURL) {
      setDocumentDetails(compareDataObj);
    } else if (!compareDataObj?.modifiedDocumentURL) {
      navigate('/');
    }
  };
  // Datasource handler for shared and saved comaprison start---

  // Navigation card scrolling Fucntion start---
  const cardScroll = (navId) => {
    const cardElement = document.getElementById(navId);
    if (cardElement === null) {
      document.getElementById(navId)?.scrollIntoViewPromise({ behavior: 'smooth' });
    } else {
      cardElement?.scrollIntoViewPromise({ behavior: 'smooth' });
    }
  };
  // Navigation card scrolling Fucntion End---

  // Document Scrolling Function Start--
  const scrollFunction = (leftId, rightId, navId, pageIndex = null, type = '') => {
    clearTimeout(scrollFunctionTimer.docId);
    const rightPageId = `page-rightRegion-${pageIndex}`;
    const leftPageId = `page-leftRegion-${pageIndex}`;
    setTimeout(() => {
      const leftCard = document.getElementById(`${navId}-annotation-leftRegion`);
      const rightCard = document.getElementById(`${navId}-annotation-rightRegion`);

      if (leftCard === null) {
        setTimeout(() => {
          document
            .getElementById(`${navId}-annotation-leftRegion`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      } else {
        // setTimeout(() => {
        //   leftCard?.scrollIntoView({ behavior: 'auto', block: 'center' });
        // }, 180);
        // leftCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        scrollIntoView(leftCard, {
          behavior: 'smooth',
          duration: 200,
        });
      }

      if (rightCard === null) {
        setTimeout(() => {
          document
            .getElementById(`${navId}-annotation-rightRegion`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      } else {
        // setTimeout(() => {
        //   rightCard?.scrollIntoView({ behavior: 'auto', block: 'center' });
        // }, 180);
        // rightCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        scrollIntoView(rightCard, {
          behavior: 'smooth',
          duration: 200,
        });
      }

      // for deleted, we have to scroll right page into view
      // for inserted, we have to scroll left page into view
      if (type === 'inserted') {
        const leftPage = document.getElementById(leftPageId);
        if (leftPage === null) {
          setTimeout(() => {
            document.getElementById(leftPageId)?.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        } else {
          leftPage.scrollIntoViewPromise({ behavior: 'smooth' }, 200);
        }
      } else if (type === 'deleted') {
        const rightPage = document.getElementById(rightPageId);
        if (rightPage === null) {
          setTimeout(() => {
            document.getElementById(rightPageId)?.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        } else {
          rightPage.scrollIntoViewPromise({ behavior: 'smooth' }, 200);
        }
      }

      // scroll navigation card into view
      cardScroll(navId);

      // (document.getElementById(rightId)
      //   ? document.getElementById(rightId)
      //   : document.body
      // )
      //   ?.scrollIntoViewPromise({ behavior: 'smooth' })
      //   ?.then(() => {
      //     (document.getElementById(leftId)
      //       ? document.getElementById(leftId)
      //       : document.body
      //     )
      //       ?.scrollIntoViewPromise({ behavior: 'smooth' })
      //       .then(() => {
      //         if (pageIndex) {
      //           if (type === 'deleted') {
      //             (document.getElementById(rightPageId)
      //               ? document.getElementById(rightPageId)
      //               : document.body
      //             )
      //               ?.scrollIntoViewPromise({ behavior: 'smooth' })
      //               .then(() => cardScroll(navId));
      //           } else if (type === 'inserted') {
      //             (document.getElementById(leftPageId)
      //               ? document.getElementById(leftPageId)
      //               : document.body
      //             )
      //               .scrollIntoViewPromise({ behavior: 'smooth' })
      //               .then(() => cardScroll(navId));
      //           }
      //         } else {
      //           cardScroll(navId);
      //         }
      //       });
      //   });
    }, 100);
  };
  // Document Scrolling Function End--

  // Navigation Error function Start--
  const showNavigationErrorDialogue = () => {
    message.error({
      content: 'Currently not able to navigate',
      style: {
        marginRight: '-34%',
        marginTop: '45vh',
      },
    });
  };
  // Navigation Error function End--

  // Navigation and Scroll Function Start----
  const navigateTo = ({
    index,
    id,
    navigationData,
    showNavigationError = false,
    pageIndex,
    type,
  }) => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
    }
    if (showNavigationError) {
      showNavigationErrorDialogue(true);
    } else {
      let navId = null;
      let navIndex = null;
      let documentPageNumber = null;
      let cardType = null;
      if (navigationData === nextChange) {
        navId = cardData[card.index + 1]?.id;
        documentPageNumber = cardData[card.index + 1]?.page_index;
        cardType = cardData[card.index + 1]?.kind;
        navIndex = card.index + 1;
        if (!documentPageNumber) {
          setTotalRegionPages({
            leftRegion:
              checkBoxDetails.original_page_index + 1 || checkBoxDetails.originalTotalPage,
            rightRegion:
              checkBoxDetails.modified_page_index + 1 || checkBoxDetails.modifiedTotalPage,
            singleRegion: checkBoxDetails.singleViewTotalPage,
          });
        }

        if (cardData[card.index + 1]?.error) {
          showNavigationErrorDialogue(true);
        }
      } else if (navigationData === prevChange) {
        navId = cardData[card.index - 1]?.id;
        documentPageNumber = cardData[card.index - 1]?.page_index;
        cardType = cardData[card.index - 1]?.kind;
        navIndex = card.index - 1;
        if (cardData[card.index - 1]?.error) {
          showNavigationErrorDialogue(true);
        }
      } else if (navigationData === firstChange) {
        documentPageNumber = cardData[0]?.page_index;
        cardType = cardData[0]?.kind;
        navId = cardData[0]?.id;
        navIndex = 0;
        if (cardData[0]?.error) {
          showNavigationErrorDialogue(true);
        }
      } else if (navigationData === lastChange) {
        navId = allCardData[allCardData.length - 1]?.id;
        documentPageNumber = allCardData[allCardData.length - 1]?.page_index;
        cardType = allCardData[allCardData.length - 1]?.kind;
        navIndex = allCardData.length - 1;
        setTotalRegionPages({
          leftRegion: checkBoxDetails.originalTotalPage,
          rightRegion: checkBoxDetails.modifiedTotalPage,
          singleRegion: checkBoxDetails.singleViewTotalPage,
        });
        if (
          cardData.length < allCardData.length ||
          (cardData.length === allCardData.length && !canLoadCards)
        ) {
          const last = (allCardData.length / 100).toFixed(0);
          for (let i = 1; i <= last; i++) {
            lastIndex += 100;
            const slicedData = allCardData.slice(0, lastIndex);
            setCardData(slicedData);
          }
        }
        if (allCardData[allCardData.length - 1]?.error) {
          showNavigationErrorDialogue(true);
        }
      } else {
        navId = id;
        navIndex = index;
        documentPageNumber = pageIndex;
        cardType = type;

        setTotalRegionPages({
          leftRegion: checkBoxDetails.originalTotalPage,
          rightRegion: checkBoxDetails.modifiedTotalPage,
          singleRegion: checkBoxDetails.singleViewTotalPage,
        });
      }
      if (index !== 'headings') {
        setCard({
          id: navId,
          index: navIndex,
          page_index: pageIndex,
          kind: type,
        });
      }
      setVisibleIndex(navId);
      const leftId = `${id || navId}-leftRegion`;
      const rightId = `${id || navId}-rightRegion`;
      const newTimeout = setTimeout(() => {
        scrollFunction(leftId, rightId, navId, documentPageNumber, cardType);
      }, 300);
      // TODO: use local variable instead of state variable to avoid re-render
      setClickTimeout(newTimeout);
    }
  };

  // Navigation and Scroll Function End----

  // Document Page Load Handler Start----
  const handlePages = (targetRegion) => {
    setPage((prev) => {
      if (targetRegion === 'leftRegion') {
        return {
          ...prev,
          ORIGINAL_DOCUMENT: {
            ...prev.ORIGINAL_DOCUMENT,
            currentMax: prev.ORIGINAL_DOCUMENT.currentMax + 10,
          },
        };
      }
      if (targetRegion === 'rightRegion') {
        return {
          ...prev,
          MODIFIED_DOCUMENT: {
            ...prev.MODIFIED_DOCUMENT,
            currentMax: prev.MODIFIED_DOCUMENT.currentMax + 10,
          },
        };
      }
      return {
        ...prev,
        SINGLE_DOCUMENT: {
          ...prev.SINGLE_DOCUMENT,
          currentMax: prev.SINGLE_DOCUMENT.currentMax + 10,
        },
      };
    });

    if (
      (targetRegion === 'leftRegion' && canLoadPage[0]) ||
      (targetRegion === 'rightRegion' && canLoadPage[1]) ||
      (targetRegion === 'singleRegion' && canLoadPage[2])
    ) {
      setTotalRegionPages((prevIndex) => {
        if (targetRegion === 'leftRegion') {
          return { ...prevIndex, leftRegion: prevIndex.leftRegion + 10 };
        }
        if (targetRegion === 'rightRegion') {
          return { ...prevIndex, rightRegion: prevIndex.rightRegion + 10 };
        }
        return { ...prevIndex, singleRegion: prevIndex.singleRegion + 10 };
      });
    }

    if (totalRegionPages.leftRegion + 10 > checkBoxDetails?.originalTotalPage && canLoadPage[0]) {
      canLoadPage[0] = false;
      setTotalRegionPages((prevIndex) => ({
        ...prevIndex,
        leftRegion: checkBoxDetails.originalTotalPage,
      }));
      return;
    }
    if (totalRegionPages.rightRegion + 10 > checkBoxDetails.modifiedTotalPage && canLoadPage[1]) {
      canLoadPage[1] = false;
      setTotalRegionPages((prevIndex) => ({
        ...prevIndex,
        rightRegion: checkBoxDetails.modifiedTotalPage,
      }));
    }
    if (
      totalRegionPages.singleRegion + 10 > checkBoxDetails.singleViewTotalPage &&
      canLoadPage[2]
    ) {
      canLoadPage[2] = false;
      setTotalRegionPages((prevIndex) => ({
        ...prevIndex,
        singleRegion: checkBoxDetails.singleViewTotalPage,
      }));
    }
  };
  // Document Page Load Handler End----

  // Document Page detection Start----

  const pageFinder = (documentType, pageNum) => {
    isScrolling = true;
    let id;
    let region;
    let currentMax;
    if (documentType === 'ORIGINAL_DOCUMENT') {
      id = `page-leftRegion-${pageNum}`;
      region = 'leftRegion';
      currentMax = page.ORIGINAL_DOCUMENT.currentMax;
    } else if (documentType === 'SINGLE_DOCUMENT') {
      id = `page-singleRegion-${pageNum}`;
      region = 'singleRegion';
      currentMax = page.SINGLE_DOCUMENT.currentMax;
    } else {
      id = `page-rightRegion-${pageNum}`;
      region = 'rightRegion';
      currentMax = page.MODIFIED_DOCUMENT.currentMax;
    }
    const targetPage = document.getElementById(id);
    targetPage?.scrollIntoViewPromise({ behavior: 'smooth', block: 'center' });
    ({
      behavior: 'smooth',
    });
    clearTimeout(scrollTimeoutRef.current);
    scrollTimeoutRef.current = setTimeout(() => {
      isScrolling = false;
    }, 500);
    if (pageNum > currentMax - 2) {
      handlePages(region);
    }
  };
  // Document Page Detection End----

  // Editable Page Number Goto Start----

  function goToPage(documetype, pageNum) {
    const number = parseInt(pageNum);
    if (documetype === originalDocument) {
      setPage((prev) => ({
        // ...prev
        ...prev,
        ORIGINAL_DOCUMENT: {
          ...prev.ORIGINAL_DOCUMENT,
          number,
        },
      }));
      delay(() => pageFinder(originalDocument, number), 300);
    } else if (documetype === singleDocument) {
      setPage((prev) => ({
        // ...prev
        ...prev,
        SINGLE_DOCUMENT: {
          ...prev.SINGLE_DOCUMENT,
          number,
        },
      }));
      delay(() => pageFinder(singleDocument, number), 300);
    } else {
      setPage((prev) => ({
        ...prev,
        MODIFIED_DOCUMENT: {
          ...prev.MODIFIED_DOCUMENT,
          number,
        },
      }));

      delay(() => pageFinder(modifiedDocument, number), 300);
    }
  }
  // Editable Page Number Goto Start----

  // Infinite scrolling Scroll Handler start----
  const handleScroll = (e) => {
    if (!canLoadCards) return;
    const bottomSpaceLeftToScroll =
      e.target.scrollHeight - 20 - e.target.scrollTop - e.target.clientHeight;
    if (bottomSpaceLeftToScroll > 1) return;
    lastIndex += 50;
    setCardData(allCardData.slice(0, lastIndex));
    if (lastIndex > allCardData.length) {
      canLoadCards = false;
    }
  };

  // Infinite scrolling Scroll Handler End----

  // Page number handler start-------
  const handlePageScroll = (e) => {
    if (!isScrolling) {
      const canHeight = compareData?.annotationData?.[0]?.leftRegion?.size?.height
        ? Number(compareData?.annotationData[0]?.leftRegion?.size?.height?.slice(0, -2))
        : 842;
      let height;
      let margin;
      if (e.target.id === 'leftRegion') {
        height = canHeight * (+zoomLevel.ORIGINAL_DOCUMENT + 0.1);
        margin = 16 * (+page.ORIGINAL_DOCUMENT.number - 1);
      } else if (e.target.id === 'rightRegion') {
        height = canHeight * (+zoomLevel.MODIFIED_DOCUMENT + 0.1);
        margin = 16 * (+page.MODIFIED_DOCUMENT.number - 1); // Use MODIFIED_DOCUMENT.number here
      } else if (e.target.id === 'singleRegion') {
        height = canHeight * (+zoomLevel.SINGLE_DOCUMENT + 0.1);
        margin = 16 * (+page.SINGLE_DOCUMENT.number - 1); // Use SINGLE_DOCUMENT.number here
      }

      const currentPage = +((e.target.scrollTop - margin) / height).toFixed(0) + 1;

      if (
        e.target.id === 'leftRegion' &&
        currentPage !== page.ORIGINAL_DOCUMENT.number &&
        currentPage <= checkBoxDetails.originalTotalPage
      ) {
        setPage((prev) => ({
          ...prev,
          ORIGINAL_DOCUMENT: {
            ...prev.ORIGINAL_DOCUMENT,
            number: currentPage,
          },
        }));
      } else if (
        e.target.id === 'rightRegion' &&
        currentPage !== page.MODIFIED_DOCUMENT.number && // Use MODIFIED_DOCUMENT.number here
        currentPage <= checkBoxDetails.modifiedTotalPage
      ) {
        setPage((prev) => ({
          ...prev,
          MODIFIED_DOCUMENT: {
            ...prev.MODIFIED_DOCUMENT,
            number: currentPage,
          },
        }));
      } else if (
        e.target.id === 'singleRegion' &&
        currentPage !== page.SINGLE_DOCUMENT.number && // Use MODIFIED_DOCUMENT.number here
        currentPage <= checkBoxDetails.singleViewTotalPage
      ) {
        setPage((prev) => ({
          ...prev,
          SINGLE_DOCUMENT: {
            ...prev.SINGLE_DOCUMENT,
            number: currentPage,
          },
        }));
      }

      //-----------------------------------------------------------
      if (e.target.id === 'leftRegion' && !canLoadPage[0]) {
        return;
      }
      if (e.target.id === 'rightRegion' && !canLoadPage[1]) {
        return;
      }
      if (e.target.id === 'singleRegion' && !canLoadPage[2]) {
        return;
      }
      const bottomSpaceLeftToScroll =
        e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
      if (bottomSpaceLeftToScroll > 2) return;
      handlePages(e.target.id);
    }
  };

  // Page number handler End-------

  // Rename Handler Start-----

  // const renameHandler = (title) => {
  //   let duplicateFound = false;
  //   compareData?.savedComparisons?.map((_) => {
  //     if (_.title === title && _.id !== compareData.comparisonId) {
  //       duplicateFound = true;
  //     }
  //   });
  //   setEditTitle({ ...editTitle, duplicateFound });

  //   setDocumentDetails({ ...documentDetails, comparisonTitle: title });
  // };
  const renameHandler = (title) => {
    let duplicateFound = false;

    // Use Object.values to get an array of all savedComparisons values
    const allComparisons = Object.values(compareData?.savedComparisons || {});

    // Flatten the array of arrays into a single array
    const allComparisonItems = [].concat(...allComparisons);

    // Check for duplicates
    allComparisonItems.forEach((comparison) => {
      if (comparison.title === title && comparison.id !== compareData.comparisonId) {
        duplicateFound = true;
      }
    });

    // Set state based on duplicate status
    setEditTitle({ ...editTitle, duplicateFound });

    // Set document details
    setDocumentDetails({ ...documentDetails, comparisonTitle: title });
  };

  // Rename Handler End-----

  // Save Rename Comparison Handler Start-----

  const renameSaveHandler = async () => {
    try {
      setEditTitle({ ...editTitle, editLoader: true });
      trackButtonClick({ type: 'Rename comparison' });
      await dispatch(renameTitle(documentDetails.comparisonId, documentDetails.comparisonTitle));
      await dispatch(getSavedComparisons());
      setEditTitle({
        isVisible: false,
        tempTitle: '',
        duplicateFound: false,
        editLoader: false,
      });
    } catch (e) {
      setDocumentDetails({
        ...documentDetails,
        comparisonTitle: editTitle.tempTitle,
      });
      setEditTitle({
        isVisible: false,
        tempTitle: '',
        duplicateFound: false,
        editLoader: false,
      });
    }
  };

  // Save Rename Comparison Handler End-----

  // Editable page Handler Start-----

  const editablePageHandler = (region, value) => {
    if (regexForNumber.test(value)) {
      switch (region) {
        case 'leftRegion': {
          return (
            value <= documentDetails?.documentsMetaData?.[currentDocument?.left]?.total_page &&
            setPage((prev) => {
              if (value > 10) {
                setTotalRegionPages({
                  leftRegion: checkBoxDetails.originalTotalPage,
                  rightRegion: checkBoxDetails.modifiedTotalPage,
                  singleRegion: checkBoxDetails.singleViewTotalPage,
                });
              }
              goToPage(originalDocument, value);

              return {
                ...prev,
                ORIGINAL_DOCUMENT: {
                  ...prev.ORIGINAL_DOCUMENT,
                  number: value,
                },
              };
            })
          );
        }
        case 'rightRegion':
          return (
            value <= documentDetails?.documentsMetaData?.[currentDocument?.right]?.total_page &&
            setPage((prev) => {
              if (value > 10) {
                setTotalRegionPages({
                  leftRegion: checkBoxDetails.originalTotalPage,
                  rightRegion: checkBoxDetails.modifiedTotalPage,
                  singleRegion: checkBoxDetails.singleViewTotalPage,
                });
              }
              goToPage(modifiedDocument, value);
              return {
                ...prev,
                MODIFIED_DOCUMENT: {
                  ...prev.MODIFIED_DOCUMENT,
                  number: value,
                },
              };
            })
          );
        case 'singleRegion':
          return (
            value <= documentDetails?.documentsMetaData?.[currentTab]?.total_page &&
            setPage((prev) => {
              if (value > 10) {
                setTotalRegionPages({
                  leftRegion: checkBoxDetails.originalTotalPage,
                  rightRegion: checkBoxDetails.modifiedTotalPage,
                  singleRegion: checkBoxDetails.singleViewTotalPage,
                });
              }
              goToPage(singleDocument, value);
              return {
                ...prev,
                SINGLE_DOCUMENT: {
                  ...prev.SINGLE_DOCUMENT,
                  number: value,
                },
              };
            })
          );
      }
    }
  };

  // Editable page Handler End-----

  // Share comparison hanlder start----
  const handleShareComparison = (isShowModal) => {
    setOpenShareModal(isShowModal);
  };

  function underlineElement(id) {
    const currentElement = document.getElementById(id);
    // Remove underline from the previous element
    if (previousElement) {
      previousElement.style.textDecoration = 'none';
    }

    // Add underline to the current element
    if (currentElement) {
      currentElement.style.textDecoration = 'underline';
      // Update the previous element
      previousElement = currentElement;
    }
  }

  const printRecursion = (arr, headingIdsArray, expandableArray) => {
    if (!arr) {
      setSearchResultData(headingIdsArray);
      return;
    }
    arr.forEach((item) => {
      if (searchingText.length > 0) {
        if (item.heading.toLowerCase().includes(searchingText.toLowerCase())) {
          headingIdsArray.push(item.id);
          const parentIds = item?.parent_id || [];
          expandableArray.push(...parentIds);
        }
      }
      item.title = (
        <p
          className={`overflowText ${item.mode}  ${
            item.heading.toLowerCase().includes(searchingText.toLowerCase()) &&
            searchingText.length > 0
              ? `hightlight-exact-match-${item.mode}`
              : ''
          } `}
          id={
            item.heading.toLowerCase().includes(searchingText.toLowerCase())
              ? `exact-match-${item.id}`
              : null
          }
          onClick={() => {
            navigateTo({
              index: 'headings',
              id: item.id,
              showNavigationError: item.error,
              pageIndex: item.page_index,
              type: item.mode,
            });

            const cardIndex = allCardData.indexOf(
              allCardData?.find((items) => items?.id === item.id)
            );

            if (cardIndex >= 0) {
              let pageIndex;
              let kindType;
              allCardData.forEach((items) => {
                if (items?.id === item?.id) {
                  kindType = items?.kind;
                  pageIndex = items?.page_index;
                }
              });
              setCard({
                id: item.id,
                index: allCardData.indexOf(allCardData?.find((items) => items?.id === item.id)),
                page_index: pageIndex,
                kind: kindType,
              });
              setCardData(allCardData);
            }
          }}
        >
          {searchingText.length > 0 ? (
            item.heading
              .toString()
              .split(new RegExp(`(${searchingText.toLowerCase()})`, 'gi'))
              .map((part, index) =>
                part.toLowerCase() === searchingText.toLowerCase() ? (
                  <span
                    // couldn't find a better way
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    className={item.mode === 'unchanged' ? 'fw-600 blue-600' : 'fw-600'}
                  >
                    {part}
                  </span>
                ) : (
                  part
                )
              )
          ) : (
            <Tooltip
              placement='left'
              title={
                shortenStringWithEllipsis(item.heading).includes('....')
                  ? item.heading.substring(0, 100)
                  : null
              }
              color='#27374A'
            >
              <span>{shortenStringWithEllipsis(item.heading)}</span>
            </Tooltip>
          )}
        </p>
      );
      item.children = item.sub_headings;
      item.key = item.id;
      printRecursion(item.sub_headings, headingIdsArray, expandableArray);
    });

    if (arr.length > 0) {
      setHeadingData(arr);
    }
  };

  function searchNestedArray(arr, searchText) {
    for (const obj of arr) {
      if (obj.heading.toLowerCase().includes(searchText)) {
        return true;
      }
      if (obj.sub_headings && obj.sub_headings.length > 0) {
        const result = searchNestedArray(obj.sub_headings, searchText);
        if (result) {
          return result;
        }
      }
    }
    return false;
  }

  const handleBookmark = (id, flag) => {
    dispatch(addRemoveBookmark(documentDetails.comparisonId, id, flag));
  };

  return (
    <div className='viewer-container'>
      {reAnalysisStatus === LOADING && <Loader time='450' type={RE_ANALYSIS} />}
      <div className={`${reAnalysisStatus === LOADING && 'blur3px'} viewer-display`}>
        <Navbar product={DOC_COMPARE} />

        {isLoaderOpen && <Loader time='300' />}
        {documentDetails?.documentsMetaData?.length > 0 ? (
          <main className='main-container'>
            <SavedComparisonsSidebar
              savedComparisons={savedComparisons}
              dataSourceHandler={dataSourceHandler}
            />

            {tabView ? (
              <div
                className={`single-doc-container ${docCompareSidebarVisible ? 'sidebar-expand' : ''}`}
              >
                <div
                  className='tab-container'
                  // style={{
                  //   width: `calc(100vw - 20% ${docCompareSidebarVisible ? 270 : 76}px - 132px)`,
                  // }}
                >
                  <Button
                    type='button'
                    className='tabs-scroll-btn left'
                    onClick={() =>
                      tabsScrollRef.current?.scrollBy({
                        left: -240,
                        behavior: 'smooth',
                      })
                    }
                    aria-label='Scroll left'
                  >
                    <LeftOutlined />
                  </Button>
                  <div className='tabs-scroll' ref={tabsScrollRef}>
                    {documentDetails?.documentsMetaData?.map((d, i) => {
                      return (
                        <div
                          // .pdf_url might get removed in future. Ask backend if providing an id is possible
                          key={d.pdf_url}
                          onClick={() => {
                            setCurrentTab(i);
                          }}
                          className={currentTab === i ? 'active-tab' : ''}
                        >
                          {d?.file_name}
                        </div>
                      );
                    })}
                  </div>
                  <Button
                    type='button'
                    className='tabs-scroll-btn right'
                    onClick={() =>
                      tabsScrollRef.current?.scrollBy({
                        left: 240,
                        behavior: 'smooth',
                      })
                    }
                    aria-label='Scroll right'
                  >
                    <RightOutlined />
                  </Button>
                  <div
                    className='format-container'
                    onClick={() => {
                      if (docCompareSidebarVisible) {
                        dispatch(setDocCompareSidebar(false));
                      }
                      setTabView(false);
                    }}
                  >
                    <ViewerFormat />
                  </div>
                </div>
                <div className='centre-container' id='singleRegion' onScroll={handlePageScroll}>
                  <ViewerDiv
                    url={documentDetails?.documentsMetaData[currentTab]?.pdf_url}
                    totalPages={{
                      singleRegion:
                        checkBoxDetails.singleViewTotalPage ||
                        documentDetails?.documentsMetaData?.[currentTab]?.total_page,
                      // rightRegion: checkBoxDetails.modifiedTotalPage,
                    }}
                    region='singleRegion'
                    zoomLevel={zoomLevel}
                    totalRegionPages={totalRegionPages}
                    setTotalRegionPages={setTotalRegionPages}
                    annotationData={annotationOutlineData}
                    allCardData={allCardData}
                    setCard={setCard}
                    visibleIndex={visibleIndex}
                    setVisibleIndex={setVisibleIndex}
                    setCardData={setCardData}
                    // height={
                    //   compareData.annotationData[0].leftRegion.size.height
                    // }
                  />
                </div>
              </div>
            ) : (
              <div
                className='compare-container'
                id='compare-tour-step-1'
                style={
                  tabView
                    ? {}
                    : {
                        maxWidth: `calc(100vw - 20% - ${docCompareSidebarVisible ? 270 : 76}px - 8px)`,
                        marginLeft: '8px',
                      }
                }
              >
                <div className='left-window'>
                  {/* <div className="left-header">
                    <Tooltip
                      placement="bottom"
                      title={
                        `[Original] ${documentDetails?.documentsMetaData?.original_document?.name}` ||
                        ''
                      }
                      arrow
                    >
                      {`[Original] ${documentDetails?.documentsMetaData?.original_document?.name}` ||
                        ''}
                    </Tooltip>
                  </div> */}
                  <div className='left-header'>
                    <div
                      className='format-container active'
                      onClick={() => {
                        setTabView(true);
                      }}
                    >
                      <ViewerFormat />
                    </div>
                    <Select
                      value={currentDocument?.left}
                      options={
                        documentDetails?.documentsMetaData?.map((item, i) => ({
                          value: i,
                          label: item?.file_name,
                        })) || []
                      }
                      onChange={(value) => {
                        setCurrentDocument({
                          ...currentDocument,
                          left: value,
                        });
                      }}
                    />
                  </div>

                  <div className='left-container' id='leftRegion' onScroll={handlePageScroll}>
                    <ViewerDiv
                      url={documentDetails?.documentsMetaData[currentDocument?.left]?.pdf_url}
                      totalPages={{
                        leftRegion: checkBoxDetails.originalTotalPage,
                        rightRegion: checkBoxDetails.modifiedTotalPage,
                      }}
                      region='leftRegion'
                      zoomLevel={zoomLevel}
                      totalRegionPages={totalRegionPages}
                      setTotalRegionPages={setTotalRegionPages}
                      annotationData={annotationOutlineData}
                      allCardData={allCardData}
                      setCard={setCard}
                      visibleIndex={visibleIndex}
                      setVisibleIndex={setVisibleIndex}
                      setCardData={setCardData}
                      // height={
                      //   compareData.annotationData[0].leftRegion.size.height
                      // }
                    />
                  </div>
                </div>

                <div className='right-window'>
                  {/* <div className="right-header">
                    <Tooltip
                      placement="bottom"
                      title={
                        `[Revised] ${documentDetails?.documentsMetaData?.modified_document?.name}` ||
                        ''
                      }
                      arrow
                    >
                      {`[Revised] ${documentDetails?.documentsMetaData?.modified_document?.name}` ||
                        ''}
                    </Tooltip>
                  </div> */}
                  <div className='right-header'>
                    <Select
                      value={currentDocument?.right}
                      options={
                        documentDetails?.documentsMetaData?.map((item, i) => ({
                          value: i,
                          label: item?.file_name,
                        })) || []
                      }
                      onChange={(value) => {
                        setCurrentDocument({
                          ...currentDocument,
                          right: value,
                        });
                      }}
                    />
                  </div>
                  <div className='right-container' id='rightRegion' onScroll={handlePageScroll}>
                    <ViewerDiv
                      url={documentDetails?.documentsMetaData[currentDocument?.right]?.pdf_url}
                      totalPages={{
                        leftRegion: checkBoxDetails.originalTotalPage,
                        rightRegion: checkBoxDetails.modifiedTotalPage,
                      }}
                      region='rightRegion'
                      zoomLevel={zoomLevel}
                      totalRegionPages={totalRegionPages}
                      setTotalRegionPages={setTotalRegionPages}
                      annotationData={annotationOutlineData}
                      allCardData={allCardData}
                      setCard={setCard}
                      visibleIndex={visibleIndex}
                      setVisibleIndex={setVisibleIndex}
                      checkBoxDetails={checkBoxDetails}
                      setCardData={setCardData}
                      // height={
                      //   compareData.annotationData[0].rightRegion.size.height
                      // }
                    />
                  </div>
                </div>

                {/* HERE */}
              </div>
            )}
            <div className='data-cards-container'>
              <div className='data-cards-header'>
                <div className='flex fw-600 color-n8' style={{ flexFlow: 'wrap' }}>
                  {filteredCards?.length === 0
                    ? 'No Result Found'
                    : `Result (${filteredCards?.length})`}
                </div>

                <div>
                  <div
                    className='bookmark-btn'
                    onClick={() => {
                      setFilter((prev) => ({
                        ...prev,
                        showBookmark: !prev?.showBookmark,
                      }));
                    }}
                  >
                    {filter?.showBookmark ? (
                      <StarFilled
                        style={{
                          color: '#0066FF',
                        }}
                      />
                    ) : (
                      <StarTwoTone />
                    )}
                  </div>

                  <button
                    className={`filter-btn ${
                      compareData?.finalComparison?.length === 0 && 'notAllowed'
                    }`}
                    onClick={() => {
                      setIsFilterOpen(!isFilterOpen);
                    }}
                    disabled={compareData?.finalComparison?.length === 0}
                  >
                    <FilterIcon
                      color={compareData?.finalComparison?.length === 0 ? '#C0C4CA' : '#5A6675'}
                    />
                  </button>
                </div>
              </div>
              <CompareFilters
                isFilterOpen={isFilterOpen}
                setIsFilterOpen={setIsFilterOpen}
                setAllCardData={setAllCardData}
                compareData={documentDetails?.finalComparison}
                setTotalRegionPages={setTotalRegionPages}
                checkBoxDetails={checkBoxDetails}
                filterRef={filterRef}
                reAnlysisng={reAnalysisStatus}
                files={documentDetails?.documentsMetaData}
                filter={filter}
                setFilter={setFilter}
              />

              <div
                className='data-cards-inner'
                onScroll={handleScroll}
                style={{ height: window.innerHeight - 185 }}
              >
                {filteredCards?.length === 0 ? (
                  <div className='zero_result-container'>
                    <ZeroResultIcon />
                  </div>
                ) : (
                  filteredCards?.map((item) => (
                    <div
                      key={`filtered-compare-cards-${item.id}`}
                      // id={item.id}
                      className='card-wraper'
                    >
                      <ComparisonCard
                        fullData={item}
                        // card={card}
                        files={documentDetails?.documentsMetaData}
                        handleBookmark={handleBookmark}
                      />
                    </div>
                  ))
                )}
              </div>
              {/* )} */}
            </div>
          </main>
        ) : null}

        <ViewerFooter
          page={page}
          goToPage={goToPage}
          zoomLevel={zoomLevel}
          setZoomLevel={setZoomLevel}
          documentDetails={documentDetails?.documentsMetaData}
          handleShareComparison={handleShareComparison}
          editablePageHandler={editablePageHandler}
          currentTab={currentTab}
          tabView={tabView}
          currentDocument={currentDocument}
          sideBarVisible={docCompareSidebarVisible}
        />

        {openShareModal ? (
          <ShareFileComparison
            openShareModal={openShareModal}
            handleShareComparison={handleShareComparison}
            sharedUrl={`${sharableUrl}?uuid=${compareData.sharedURL.split('/').pop()}&type=SHARED`}
            id='viewer'
          />
        ) : null}
      </div>

      {reAnalysisStatus !== LOADING && (
        <Modal
          footer={false}
          className='comparison-error-modal'
          open={
            showError?.flag &&
            ((filter?.showComparison?.length > 0 && showError?.isComparisonErr) ||
              (filter?.showContradiction?.length > 0 && showError?.isContradictionErr))
          }
          centered
          closable={false}
          onCancel={() => {
            setShowError({
              flag: false,
              isComparisonErr: false,
              isContradictionErr: false,
            });
          }}
        >
          <h2>
            {showError?.isComparisonErr &&
            showError?.isContradictionErr &&
            filter?.showComparison?.length > 0 &&
            filter?.showContradiction?.length > 0
              ? 'No Results'
              : showError?.isComparisonErr && filter?.showComparison?.length > 0
                ? "Comparison didn't complete"
                : showError?.isContradictionErr && filter?.showContradiction?.length > 0
                  ? "Internal Contradiction didn't complete"
                  : ''}
          </h2>

          <CompareErr />
          <p>
            This{' '}
            {showError?.isComparisonErr &&
            showError?.isContradictionErr &&
            filter?.showComparison?.length > 0 &&
            filter?.showContradiction?.length > 0
              ? 'comparison and internal contradiction'
              : showError?.isComparisonErr && filter?.showComparison?.length > 0
                ? 'comparison'
                : showError?.isContradictionErr && filter?.showContradiction?.length > 0
                  ? 'internal contradiction'
                  : ''}{' '}
            didn't complete due to a temporary issue.
          </p>
          <p className='bold'>Please try again shortly</p>
          <Button
            type='primary'
            onClick={() => {
              setShowError({
                flag: false,
                isComparisonErr: false,
                isContradictionErr: false,
              });
            }}
          >
            Ok
          </Button>
        </Modal>
      )}

      <Modal closable={false} open={editTitle.isVisible} footer={null}>
        <div>
          <div className='label-rename-comparison-title'>Rename comparison</div>

          <Input
            value={documentDetails?.comparisonTitle}
            onChange={(e) => renameHandler(e.target.value)}
            className='input-title-edit'
            maxLength={50}
          />
          {editTitle.duplicateFound && (
            <div className='error-message'>
              This name is already in use for another Document. Please use a different name.
            </div>
          )}
        </div>
        <div className='edit-title-modal-footer'>
          <Button
            key='submit'
            type='primary'
            onClick={renameSaveHandler}
            disabled={editTitle.duplicateFound}
            loading={editTitle.editLoader}
          >
            Save
          </Button>
          &nbsp; &nbsp;
          <Button
            key='back'
            danger
            onClick={() => {
              setEditTitle({
                isVisible: false,
                tempTitle: '',
                duplicateFound: false,
                editLoader: false,
              });
              setDocumentDetails({
                ...documentDetails,
                comparisonTitle: editTitle.tempTitle,
              });
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default Viewer;
